// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PXNLA","body":"styles_body__Yzppb","title":"styles_title__mUea-","dates":"styles_dates__5r8aw"};